import { useCallback } from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';

import routes from 'routes.js';

export default function GameLayout() {
  const getRoute = useCallback(() => {
    return window.location.pathname !== '/full-screen-maps';
  }, []);

  const getRoutes = useCallback((routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === '/game') {
        return (
          <Route path={prop.layout + prop.path} key={key}>
            {(routerProps) => <prop.component {...routerProps} />}
          </Route>
        );
      }
    });
  }, []);

  return (
    <>
      {getRoute() ? (
        <Switch>
          {getRoutes(routes)}
          {/* <Redirect from="/" to="/giveaways" /> */}
        </Switch>
      ) : null}
    </>
  );
}
